// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x6YbhmAco1CY2Djr0xj0{align-items:center;display:flex}.ffccJzEMhnsVqa_IcitI{opacity:.5;pointer-events:none}.ku43zf8oT40LQSZGvoxH{border:1px solid var(--border-neutral-default);background:var(--background-primary-Inverted-primary);color:var(--content-primary-primary);cursor:pointer;border-radius:6px;padding:4px 8px;font-size:13px;font-weight:400;line-height:16px}.ku43zf8oT40LQSZGvoxH:hover{box-shadow:none;background:var(--action-outlined-secondary-hovered);color:var(--content-brand-secondary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemsContainer": `x6YbhmAco1CY2Djr0xj0`,
	"disabled": `ffccJzEMhnsVqa_IcitI`,
	"remainderCount": `ku43zf8oT40LQSZGvoxH`
};
export default ___CSS_LOADER_EXPORT___;
